import { Component } from '@angular/core';
import { FeedbackPlatformSessionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Sessions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformsession-form',
    templateUrl: './feedbackplatformsession.form.component.html'
})
export class FeedbackPlatformSessionFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformSessionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'presentations', sectionName: 'Presentations', isExpanded: false },
            { sectionKey: 'sessionNominators', sectionName: 'Session Nominators', isExpanded: false }
        ]);
    }
}

